export enum VersionState {
	Draft,
	Published,
	Superceded
}
